import { Observable } from 'rxjs';

import { ListResponse } from '@daikin-tic/dxone-com-lib';

import {
  Checklist,
  ChecklistCondition,
  ChecklistConditionQueryParams,
  ChecklistConditionsCreateParams,
  ChecklistCreateParams,
  ChecklistItem,
  ChecklistItemQueryParams,
  ChecklistItemsCreateParams,
  ChecklistLink,
  ChecklistLinkQueryParams,
  ChecklistQueryParams,
} from '../models/checklist.model';
import { CloudStorage } from '../models/cloud-storage.modal';

export abstract class ChecklistGateway {
  abstract listChecklists(params: ChecklistQueryParams): Observable<ListResponse<Checklist>>;
  abstract createChecklist(params: ChecklistCreateParams): Observable<Checklist>;
  abstract deleteChecklist(checklistId: string): Observable<void>;

  abstract listChecklistLinks(checklistId: string, params: ChecklistLinkQueryParams): Observable<ListResponse<ChecklistLink>>;

  abstract getChecklistFlowchart(checklistId: string): Observable<string>;
  abstract createChecklistFlowchart(checklistId: string): Observable<CloudStorage>;

  abstract listChecklistItems(checklistId: string, params: ChecklistItemQueryParams): Observable<ListResponse<ChecklistItem>>;
  abstract createChecklistItems(checklistId: string, params: ChecklistItemsCreateParams): Observable<ListResponse<ChecklistItem>>;

  abstract listChecklistConditions(
    checklistId: string,
    params: ChecklistConditionQueryParams,
  ): Observable<ListResponse<ChecklistCondition>>;
  abstract createChecklistConditions(
    checklistId: string,
    params: ChecklistConditionsCreateParams,
  ): Observable<ListResponse<ChecklistCondition>>;
}
